import { Link } from "react-router-dom";
import logo from '../assets/Images/logo.png';
import '../assets/css/custom.css';


function Navbar() {
  return (
    <div className="container-fluid">
        <nav className="navbar navbar-expand-lg bg-body-tertiary">
            <div className="container-fluid">
                <Link className="navbar-brand d-flex justify-content-center align-items-center flex-column" to="/">
                    <img src={logo} alt="Ezio Logo" style={{ height: '50px' }} />
                    <h6 className="logoText m-0 p-0">Ezio Infotech</h6>
                </Link>
                <button className="navbar-toggler" 
                  type="button" 
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false" 
                  aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                  <ul className="navbar-nav w-100 justify-content-end gap-lg-3 mb-2 mb-lg-0">

                      <li className="nav-item">
                      <Link className="nav-link fs-5 active" aria-current="page" to="/">Home</Link>
                      </li>
                      <li className="nav-item">
                      <Link className="nav-link fs-5 text-dark" to="/about">About</Link>
                      </li>
                      <li className="nav-item">
                      <Link className="nav-link fs-5 text-dark" to="/service">Service</Link>
                      </li>
                      <li className="nav-item">
                      <Link className="nav-link fs-5 text-dark" to="/product">Product</Link>
                      </li>
                      <li className="nav-item">
                      <Link className="nav-link fs-5 text-dark" to="/team">Team</Link>
                      </li>
                      <li className="nav-item">
                      <Link className="nav-link fs-5 text-dark" to="/blog">Blog</Link>
                      </li>
                      <li className="nav-item">
                      <Link className="nav-link fs-5 text-dark" to="/carrer">Career</Link>
                      </li>
                      <li className="nav-item">
                      <Link className="nav-link fs-5 text-dark" to="/contact">Contact</Link>
                      </li>
                  </ul>
                </div>
            </div>
          </nav>
    </div>
  );
}

export default Navbar;
